import * as React from 'react';
import { Body2 } from '@cian/ui-kit';
import { Stars } from '@cian/stars-component';

import * as styles from './AboutRealtorDesktop.css';

interface IRatingProps {
  text: string;
  value: number;
}

export const Rating = ({ text, value }: IRatingProps) => {
  return (
    <div className={styles['rating']}>
      <Stars percentage containerClassName={styles['rate-value']} value={value} uniqueKey="realtor-rating" />
      <Body2 textAlign="center">{text}</Body2>
    </div>
  );
};
